"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logDebugging = exports.deployed = exports.isQa = exports.setDebugGate = exports.debugGate = exports.setDebug = exports.debug = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var APP_NAME = 'ecosystem-marketplace-apps';
var GATE_PREFIX = 'gate::';

var debug = function debug() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _enviro.default.debug("" + APP_NAME + (key ? "_" + key : '')) === 'true';
};

exports.debug = debug;

var setDebug = function setDebug(key) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return _enviro.default.setDebug.apply(_enviro.default, [APP_NAME + "_" + key].concat(args));
};

exports.setDebug = setDebug;

var debugGate = function debugGate(gate) {
  return debug("" + GATE_PREFIX + gate);
};

exports.debugGate = debugGate;

var setDebugGate = function setDebugGate(gate) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key3 = 1; _key3 < _len2; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return setDebug.apply(void 0, ["" + GATE_PREFIX + gate].concat(args));
};

exports.setDebugGate = setDebugGate;

var isQa = function isQa() {
  return _enviro.default.isQa(APP_NAME);
};

exports.isQa = isQa;

var deployed = function deployed() {
  return _enviro.default.deployed(APP_NAME);
};

exports.deployed = deployed;

var logDebuggingGroup = function logDebuggingGroup(group, keys) {
  var debugFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : debug;
  console.group(group + ":");
  keys.forEach(function (key) {
    return console.log(key + ":", debugFn(key), '\n');
  });
  console.groupEnd();
};

var logDebugging = function logDebugging() {
  try {
    if (!(window && window.localStorage)) {
      return;
    }

    var keys = [];
    var gates = [];
    Object.keys(window.localStorage).forEach(function (_key) {
      var key = _key.toLowerCase();

      if (!(key.startsWith(APP_NAME) && key.endsWith('_debug'))) {
        return;
      }

      key = key.replace(APP_NAME + "_", '').replace(/_?debug$/, '');

      if (key) {
        if (key.startsWith(GATE_PREFIX)) {
          gates.push(key.replace(GATE_PREFIX, ''));
        } else {
          keys.push(key);
        }
      }
    });
    console.groupCollapsed("[" + APP_NAME + "] debugging");
    logDebuggingGroup('keys', keys);
    logDebuggingGroup('gates', gates, debugGate);
    console.groupEnd();
  } catch (__error) {
    return;
  }
};

exports.logDebugging = logDebugging;


//////////////////
// WEBPACK FOOTER
// ./js/utils/env.js
// module id = 88
// module chunks = 209 210 211 212 213